import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const ImagePlaceholder = (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 860 957"
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="0" y="0" rx="16" ry="16" width="100%" height="100%" />
  </ContentLoader>
);

export const MainPlaceholder = (props: IContentLoaderProps) => (
  <div className="placeholder business__main">
    <ContentLoader
      viewBox="0 0 860 400"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <rect x="0" y="0" rx="16" ry="16" width="80%" height="60" />
      <rect x="0" y="78" rx="16" ry="16" width="120" height="24" />
      <rect x="0" y="120" rx="16" ry="16" width="100%" height="20" />
      <rect x="0" y="158" rx="16" ry="16" width="100%" height="20" />
      <rect x="0" y="196" rx="16" ry="16" width="100%" height="20" />
    </ContentLoader>
  </div>
);

export const KeyDetailsPlaceholder = (props: IContentLoaderProps) => (
  <div className="placeholder white-panel">
    <ContentLoader
      viewBox="0 0 400 90"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      width="100%"
      {...props}
    >
      <rect x="0" y="0" rx="9" ry="9" width="80" height="14" />
      <rect x="0" y="24" rx="9" ry="9" width="120" height="66" />
      <rect x="136" y="24" rx="9" ry="9" width="120" height="66" />
      <rect x="272" y="24" rx="9" ry="9" width="120" height="66" />
    </ContentLoader>
  </div>
);

export const TitlePlaceholder = (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 550 46"
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="0" y="0" rx="16" ry="16" width="550" height="46" />
  </ContentLoader>
);

export const MapPlaceholder = (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 630 300"
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="0" y="0" rx="16" ry="16" width="630" height="300" />
  </ContentLoader>
);

export const AskingPricePlaceholder = (props: IContentLoaderProps) => (
  <div className="placeholder white-panel">
    <ContentLoader
      viewBox="0 0 560 92"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <rect x="0" y="0" rx="16" ry="16" width="560" height="32" />
      <rect x="0" y="60" rx="16" ry="16" width="560" height="32" />
    </ContentLoader>
  </div>
);

export const VideoPlaceholder = (props: IContentLoaderProps) => (
  <div className="placeholder white-panel">
    <ContentLoader
      viewBox="0 0 566 394"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <rect x="0" y="0" rx="16" ry="16" width="566" height="394" />
    </ContentLoader>
  </div>
);

export const WhatsNextPlaceholder = (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 630 296"
    backgroundColor="#e7f1fc"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="0" y="0" rx="16" ry="16" width="630" height="296" />
  </ContentLoader>
);
